import { memo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ListItem } from "@mui/material";
import { useTranslation } from "react-i18next";

const StyledListItem = styled(ListItem)(({ selected }) => ({
    display: 'flex',
    width: '100%',
    justifyContent: "center",
    alignItems: "center",
    gap: '10px',
    height: '32px',
    borderRadius: "10px",
    backgroundColor: selected ? "rgba(42, 177, 191, 0.3)" : 'transparent',
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: "rgba(42, 177, 191, 0.3)",
        '& .MuiTypography-root': {
            color: 'black',
            fontWeight: "500",
        },
        '& .MuiBox-root': {
            filter: `grayscale(0%)`
        },
    },
    userSelect: "none"
}));


const MenuItem = memo(({ item, index, isCollapsed, navigate, pathname, t, closeMenu }) => {
    var selected = pathname.includes(item.path)
    return (
        <StyledListItem
            key={index}
            typeof="button"
            selected={selected}
            onClick={() => {
                navigate(item.path)
                closeMenu?.()
            }}
        >
            {!isCollapsed && <Typography fontSize={"11px"} fontWeight={selected ? "500" : "400"} color={selected ? "black" : "#5C5E64"} >{t(item.text)}</Typography>}
        </StyledListItem>
    )
});


const CustomTreeTab = ({ tabs = [], pathname, isCollapsed, navigate, closeMenu }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ display: "flex", mt: '15px', }}>
            <Box sx={{ display: "flex", position: "relative" }}>
                <Box sx={{ height: "auto", width: "2px", backgroundColor: "#D9D9DC" }} />
                <Box position={"absolute"} height={"14.5px"} width={"12px"} backgroundColor={"#FFFFFF"} bottom={0} />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                {tabs.map((tab, index) => {
                    const selected = pathname === tab.path
                    return (
                        <Box key={index} sx={{ display: "flex", alignItems: "center", gap: "4px", width: "100%" }}>
                            <Box sx={{ width: "10px", height: "2px", backgroundColor: selected ? "#2AB1BF" : "#D9D9DC" }} />
                            <MenuItem closeMenu={closeMenu} t={t} key={index} index={index} item={tab} isCollapsed={isCollapsed} navigate={navigate} pathname={pathname} />
                        </Box>
                    )
                })}
            </Box>
        </Box>
    );
};

export default CustomTreeTab;
